module.exports = __webpack_public_path__ + "img/f1-1.6773d0fd.png";